import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Shell } from "@/components/Shell";
import { StatusBadge } from "@/components/StatusBadge";
import { EventsManager } from "@/components/EventsManager";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function TagStats() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useApp();
  const [data, setData] = useState(null);

  const load = () => api.get(`/tags/${id}/stats`).then((r) => setData(r.data));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return <Shell showNav={false}><div className="pt-20 text-center font-heading text-gray-500">…</div></Shell>;

  const eventsWithLabel = (data.events || []).map((e) => ({ ...e, tag_label: data.tag.label }));

  return (
    <Shell showNav={false}>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-heading font-semibold text-gray-900">{t("statsTitle")}</h1>
          <StatusBadge status={data.tag.status} />
        </div>
        <p className="font-body text-gray-500 mt-1">/t/{data.tag.code}</p>

        <div className="grid grid-cols-3 gap-3 mt-5">
          <div className="sb-card p-4 text-center" data-testid="tagstat-scans"><p className="text-3xl font-heading font-semibold" style={{ color: "#0EA5E9" }}>{data.tag.scans}</p><p className="text-[10px] uppercase text-gray-500 mt-1">{t("totalScans")}</p></div>
          <div className="sb-card p-4 text-center" data-testid="tagstat-calls"><p className="text-3xl font-heading font-semibold" style={{ color: "#10B981" }}>{data.tag.calls}</p><p className="text-[10px] uppercase text-gray-500 mt-1">{t("totalCalls")}</p></div>
          <div className="sb-card p-4 text-center" data-testid="tagstat-messages"><p className="text-3xl font-heading font-semibold" style={{ color: "#A855F7" }}>{data.tag.messages}</p><p className="text-[10px] uppercase text-gray-500 mt-1">{t("totalMessages")}</p></div>
        </div>

        <h2 className="text-lg font-heading font-semibold mt-7 mb-3">{t("events")}</h2>
        <EventsManager events={eventsWithLabel} onChange={load} />
      </motion.div>
    </Shell>
  );
}
